export enum KillDataViewMode {
  FLAT = 'Flat',
  NEST = 'Nest'
}